import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import styles from './styles.module.scss';
import { setSortListBy, setSwitchListBy, setChangeItem } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import { e_switchListsbBy } from '@Redux/search/interfaces';
import { ArrowUp } from '@components/Common/Icons';
import DropDowns from './subComponent/DropDowns';
import FlatBtn from './subComponent/FlatBtn';
import SwitchBtn from './subComponent/SwitchBtn';

interface I_sortOption {
    text: string;
    value: number;
}
interface DropdownProps {
    options: I_sortOption[];
}

interface I_sorterByProps {
    flatBtn: I_sortOption;
    dropdowns: DropdownProps[];
}
interface I_switchOption {
    text: string;
    value: string;
}
interface SortersProps {
    onClickFlatBtnM: () => void;
    sortByOptions: I_sorterByProps;
    switchByOptions: I_switchOption[];
}

const Sorters: React.FC<SortersProps> = ({ onClickFlatBtnM, sortByOptions, switchByOptions }) => {
    const moduleName = 'sorters';
    const dispatch = useDispatch();
    const { SortListBy, SwitchListBy, DepthInfo } = useSelector((state: RootState) => state.search);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    const FlatBtnProps = {
        text: sortByOptions.flatBtn.text,
        value: sortByOptions.flatBtn.value,
        onClicked: (value: number) => dispatch(setSortListBy(value)),
    };

    const SwitchBtnProps = {
        defaultSelect: SwitchListBy,
        options: switchByOptions,
        onSwitched: (value: string) => dispatch(setSwitchListBy(value)),
    };

    const FlatBtnPropsM = {
        text: '篩選',
        value: 0,
        onClicked: (value: number) => onClickFlatBtnM(),
    };

    const optionsM = (() => {
        const returnOptions = [sortByOptions.flatBtn];
        sortByOptions.dropdowns.forEach((optsGroup) => {
            optsGroup.options.forEach((options) => {
                if (options.value !== 0) returnOptions.push(options);
            });
        });
        const returnOptionsCopy = [...returnOptions];
        const sorted = returnOptionsCopy.sort((a, b) => a.value - b.value);
        return sorted;
    })();

    const dropDownPropsM = {
        defaultSelect: SortListBy,
        options: [...optionsM, ...switchByOptions],
        onSelect: (value: number | string) => {
            switch (value) {
                case e_switchListsbBy.List:
                case e_switchListsbBy.Cards:
                    dispatch(setSwitchListBy(value));
                    break;
                default:
                    dispatch(setSortListBy(value));
                    dispatch(setChangeItem(true));
                    break;
            }
        },
    };

    return DepthInfo?.PriceRange ? (
        <div className={cN(moduleName, styles[`${moduleName}`])}>
            {!isMobile ? (
                <ul className={cN(styles.SortersList, 'SortersList')}>
                    <li
                        className={cN(styles.SortersItem, {
                            active: SortListBy === FlatBtnProps.value,
                        })}
                    >
                        <FlatBtn {...FlatBtnProps} />
                    </li>
                    {sortByOptions.dropdowns.map((item: DropdownProps, idx: number) => {
                        const matchOpts = item.options.filter((opt) => {
                            if (opt.value !== 0) {
                                return opt.value === SortListBy;
                            }
                        });
                        const hasMatch = matchOpts.length !== 0;
                        const dropDownsPropsPC = {
                            defaultSelect: hasMatch ? SortListBy : 0,
                            options: item.options,
                            onSelect: (value: number) => {
                                dispatch(setSortListBy(value));
                                dispatch(setChangeItem(true));
                            },
                        };

                        return (
                            <li
                                key={`${idx}}`}
                                className={cN(styles.SortersItem, { active: hasMatch })}
                            >
                                <DropDowns {...dropDownsPropsPC} />
                            </li>
                        );
                    })}
                    <li className={cN(styles.SortersItem)}>
                        <SwitchBtn {...SwitchBtnProps} />
                    </li>
                </ul>
            ) : (
                <ul className={cN(styles.SortersList, styles.SortersListM)}>
                    <li className={cN(styles.SortersItem)}>
                        <FlatBtn {...FlatBtnPropsM} />
                        <div className={cN(styles.Icons)}>
                            <ArrowUp />
                        </div>
                    </li>
                    <li className={cN(styles.SortersItem)}>
                        <DropDowns {...dropDownPropsM} />
                    </li>
                </ul>
            )}
        </div>
    ) : null;
};

export default Sorters;
